/**
 * Polyfill the UUID library with the innate crypto.randomUUID function from the browser
 * Brower innate function: https://developer.mozilla.org/en-US/docs/Web/API/Crypto/randomUUID
 * NPM Library: https://www.npmjs.com/package/uuid/v/11.0.0-0
 */

import { v4 as uuidv4 } from 'uuid'

if (typeof global.crypto === 'undefined') {
  Object.defineProperty(global, 'crypto', {
    value: {},
    configurable: true
  })
}

if (typeof global.crypto.randomUUID !== 'function') {
  global.crypto.randomUUID = () => uuidv4()
}
